/**
 * Landing pública principal.
 *
 * Esta pantalla es el escaparate comercial de Mentfull y concentra:
 * - branding inicial,
 * - explicación del servicio,
 * - planes de membresía,
 * - contacto,
 * - y ahora el flujo guiado de instalación PWA para iOS/Android.
 *
 * Nota: aquí vive el flujo de instalación solicitado, fuera de dashboards.
 */
import React from "react";
import Navbar from "./Navbar";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import CertificationsSection from "./CertificationsSection";
import MembershipPlans from "./MembershipPlans";
import ContactForm from "./ContactForm";
import PwaInstallSection from "./PwaInstallSection";

const LandingPage = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <PwaInstallSection />
      <AboutSection />
      <CertificationsSection />
      <MembershipPlans />
      <ContactForm />
    </div>
  );
};

export default LandingPage;
